import { LAB_COLOR_BY_ID } from "@nano/content";
import { colorLabVi } from "../../i18n/colorlab.vi.ts";
import { labColorName } from "../../i18n/content.ts";
import { vi } from "../../i18n/vi.ts";
import { Art } from "../components/common.tsx";
import "../../styles/colorlab.css";

/** Pours in the kept line and the three-star target, under the level title. */
export function LabHudLine({ pours, target, focus }: { pours: number; target: number; focus: boolean }) {
  return (
    <span className={`puzzle-hud__moves ${focus ? "hud-focus" : ""}`} data-testid="lab-pours">
      <Art id="icon.moves" className="ico-inline" />
      {colorLabVi.pours(pours)}
      <span className="puzzle-hud__target" aria-label={vi.puzzle.target(target)}>
        <Art id="icon.target" className="ico-inline" />
        {target}
      </span>
    </span>
  );
}

function colorName(id: string): string {
  const def = LAB_COLOR_BY_ID.get(id);
  return def ? labColorName(def) : id;
}

/** A drop of essence with its accessibility mark. */
export function Swatch({ color, size = 22 }: { color: string; size?: number }) {
  const def = LAB_COLOR_BY_ID.get(color);
  if (!def) return null;
  return (
    <span className="swatch" style={{ width: size, height: size, background: def.hex }} title={labColorName(def)} aria-label={labColorName(def)} role="img">
      <Art id={def.mark} className="swatch__mark" />
    </span>
  );
}

/** The flask's recipe card: two colours, the flask, what they make. Always on screen in flask levels. */
export function LabRecipes({ mixes, focus }: { mixes: readonly { a: string; b: string; result: string }[]; focus: boolean }) {
  return (
    <div className={`lab-recipes ${focus ? "hud-focus" : ""}`} aria-label={colorLabVi.recipes} data-testid="lab-recipes">
      {mixes.map((mix) => (
        <span
          key={mix.result}
          className="lab-recipe"
          aria-label={`${colorName(mix.a)} ${colorLabVi.recipeWith} ${colorName(mix.b)} ${colorLabVi.recipeMakes} ${colorName(mix.result)}`}
        >
          <Swatch color={mix.a} />
          <Swatch color={mix.b} />
          <Art id="lab.flask" className="lab-recipe__flask" />
          <Swatch color={mix.result} />
        </span>
      ))}
    </div>
  );
}

export function LabStuck() {
  return (
    <p className="lab-stuck" role="status" data-testid="lab-stuck">
      {colorLabVi.stuck}
    </p>
  );
}
